import { render, staticRenderFns } from "./platformRules.vue?vue&type=template&id=6522dd05&scoped=true"
import script from "./platformRules.vue?vue&type=script&lang=js"
export * from "./platformRules.vue?vue&type=script&lang=js"
import style0 from "./platformRules.vue?vue&type=style&index=0&id=6522dd05&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6522dd05",
  null
  
)

export default component.exports